
import i18n from "i18next";
export const SUBJECT_I18N_KEY: Record<string, string> = {
  AR: 'subjectsList.arabic',                 // Arabe / Arabic
  FR: 'subjectsList.french',                 // Français / French
  EN: 'subjectsList.english',                // Anglais / English
  ES: 'subjectsList.spanish',                // Espagnol / Spanish
  DE: 'subjectsList.german',                 // Allemand / German
  IT: 'subjectsList.italian',                // Italien / Italian
  AMZ: 'subjectsList.amazigh',               // Amazigh / Amazigh

  MATH: 'subjectsList.math',                 // Mathématiques / Mathematics
  SVT: 'subjectsList.svt',                   // Sciences de la Vie et de la Terre / Life & Earth Sciences
  PHYS: 'subjectsList.physics_chemistry',    // Physique-Chimie / Physics & Chemistry
  ENGR: 'subjectsList.engineering_science',  // Sciences de l’ingénieur / Engineering Science
  TECH: 'subjectsList.technology',           // Technologie / Technology

  SOC: 'subjectsList.social_studies',        // Études Sociales / Social Studies
  PHILO: 'subjectsList.philosophy',          // Philosophie / Philosophy
  TRAD: 'subjectsList.translation',          // Traduction / Translation
  ART_CULT: 'subjectsList.art_culture',      // Culture artistique / Art & Culture
  BEHAV: 'subjectsList.behavior',            // Comportement / Behavior

  ISL: 'subjectsList.islamic_education',     // Éducation islamique / Islamic Education
  EPS: 'subjectsList.physical_education',    // Éducation physique / Physical Education
  INFO: 'subjectsList.computer_science',     // Informatique / Computer Science

  'SCI-ACT': 'subjectsList.science_activity', // Activité scientifique / Science Activity
  ART: 'subjectsList.art',                    // Arts plastiques / Art
  ARTS_VIS: 'subjectsList.visual_art',        // Arts visuels / Visual Arts
  MUSIC: 'subjectsList.music',                // Musique / Music
  HOME_EC: 'subjectsList.home_economics',     // Économie familiale / Home Economics

  AGRO: 'subjectsList.botany_zoology',        // Sciences végétales et animales / Botany & Zoology
  SPORT_FORM: 'subjectsList.sport_training',  // Formation sportive / Sports Training

  // ----- Sous-unités Arabe -----
  AR_CALLI: 'subjectsList.arabic_calligraphy',     // Calligraphie arabe / Arabic Calligraphy
  AR_EXPR: 'subjectsList.arabic_expression',       // Expression écrite / Arabic Expression
  AR_COPY: 'subjectsList.arabic_copy',             // Copie arabe / Arabic Copy
  AR_LISTEN: 'subjectsList.arabic_listen',         // Écoute & expression orale / Arabic Listening & Speaking
  AR_READ: 'subjectsList.arabic_read',             // Lecture arabe / Arabic Reading
  AR_SPELL: 'subjectsList.arabic_spell',           // Dictée / Arabic Spelling
  AR_EXO: 'subjectsList.arabic_exercises',         // Exercices écrits / Arabic Written Exercises
  AR_APPL: 'subjectsList.arabic_applications',     // Applications écrites / Arabic Written Applications
  AR_PROJ: 'subjectsList.arabic_project',          // Projet de l’unité / Arabic Project
  AR_GRAM: 'subjectsList.arabic_grammar',          // Grammaire arabe / Arabic Grammar
  AR_MORPH: 'subjectsList.arabic_morphology',      // Morphologie & conjugaison / Arabic Morphology
  AR_ORAL: 'subjectsList.arabic_oral',             // Expression orale / Arabic Oral
  AR_VOWEL: 'subjectsList.arabic_vowels',          // Vocalisation (voyellation) / Arabic Vowels
  AR_COMP: 'subjectsList.arabic_comprehension',    // Compréhension écrite / Arabic Reading Comprehension
  AR_WRIT: 'subjectsList.arabic_writing',          // Rédaction / Arabic Writing
  AR_ORAL2: 'subjectsList.arabic_oral_alt',        // Expression orale (variante) / Arabic Oral (alt.)

  // ----- Sous-unités Français -----
  FR_PROJ: 'subjectsList.french_project',          // Projet de classe / French Project
  FR_ORAL: 'subjectsList.french_oral',             // Activités orales / French Oral
  FR_GRAPH: 'subjectsList.french_graph',           // Graphisme / French Graph
  FR_SONG: 'subjectsList.french_song',             // Comptine / Chant / French Song
  FR_EXPR: 'subjectsList.french_expression',       // Production écrite / French Writing
  FR_LEX: 'subjectsList.french_lexicon',           // Lexique / French Vocabulary
  FR_GRAM: 'subjectsList.french_grammar',          // Grammaire / French Grammar
  FR_CONJ: 'subjectsList.french_conjugation',      // Conjugaison / French Conjugation
  FR_SPELL: 'subjectsList.french_spelling',        // Orthographe / Dictée / French Spelling
  FR_COPY: 'subjectsList.french_copy',             // Copie / French Copy
  FR_DICT: 'subjectsList.french_dictation',        // Dictée / French Dictation
  FR_POEM: 'subjectsList.french_poetry',           // Poésie / French Poetry
  FR_READ: 'subjectsList.french_reading',          // Lecture / French Reading
  FR_WRITE: 'subjectsList.french_writing',         // Écriture / French Writing
  FR_EXO: 'subjectsList.french_exercises',         // Exercices écrits / French Exercises
  FR_PROD: 'subjectsList.french_production',       // Production écrite / French Writing Production
  FR_LECT: 'subjectsList.french_reading_activity', // Activités de lecture / French Reading Activity
  FR_COMM: 'subjectsList.french_communication',    // Communication & actes de langage / French Communication
  FR_POEM2: 'subjectsList.french_poetry_alt',      // Poésie / Lecture / Diction / French Poetry (alt.)

  // ----- Sous-unités Sociales -----
  HIST: 'subjectsList.history',                   // Histoire / History
  GEO: 'subjectsList.geography',                  // Géographie / Geography
  CIV: 'subjectsList.civics',                     // Éducation civique / Civics
};


export const SUBJECTCODE_I18N_KEY: Record<string, string> = {
  AR: 'subjectsListCode.arabic',                 // Arabe / Arabic
  FR: 'subjectsListCode.french',                 // Français / French
  EN: 'subjectsListCode.english',                // Anglais / English
  ES: 'subjectsListCode.spanish',                // Espagnol / Spanish
  DE: 'subjectsListCode.german',                 // Allemand / German
  IT: 'subjectsListCode.italian',                // Italien / Italian
  AMZ: 'subjectsListCode.amazigh',               // Amazigh / Amazigh

  MATH: 'subjectsListCode.math',                 // Mathématiques / Mathematics
  SVT: 'subjectsListCode.svt',                   // Sciences de la Vie et de la Terre / Life & Earth Sciences
  PHYS: 'subjectsListCode.physics_chemistry',    // Physique-Chimie / Physics & Chemistry
  ENGR: 'subjectsListCode.engineering_science',  // Sciences de l’ingénieur / Engineering Science
  TECH: 'subjectsListCode.technology',           // Technologie / Technology

  SOC: 'subjectsListCode.social_studies',        // Études Sociales / Social Studies
  PHILO: 'subjectsListCode.philosophy',          // Philosophie / Philosophy
  TRAD: 'subjectsListCode.translation',          // Traduction / Translation
  ART_CULT: 'subjectsListCode.art_culture',      // Culture artistique / Art & Culture
  BEHAV: 'subjectsListCode.behavior',            // Comportement / Behavior

  ISL: 'subjectsListCode.islamic_education',     // Éducation islamique / Islamic Education
  EPS: 'subjectsListCode.physical_education',    // Éducation physique / Physical Education
  INFO: 'subjectsListCode.computer_science',     // Informatique / Computer Science

  'SCI-ACT': 'subjectsListCode.science_activity', // Activité scientifique / Science Activity
  ART: 'subjectsListCode.art',                    // Arts plastiques / Art
  ARTS_VIS: 'subjectsListCode.visual_art',        // Arts visuels / Visual Arts
  MUSIC: 'subjectsListCode.music',                // Musique / Music
  HOME_EC: 'subjectsListCode.home_economics',     // Économie familiale / Home Economics

  AGRO: 'subjectsListCode.botany_zoology',        // Sciences végétales et animales / Botany & Zoology
  SPORT_FORM: 'subjectsListCode.sport_training',  // Formation sportive / Sports Training

  // ----- Sous-unités Arabe -----
  AR_CALLI: 'subjectsListCode.arabic_calligraphy',     // Calligraphie arabe / Arabic Calligraphy
  AR_EXPR: 'subjectsListCode.arabic_expression',       // Expression écrite / Arabic Expression
  AR_COPY: 'subjectsListCode.arabic_copy',             // Copie arabe / Arabic Copy
  AR_LISTEN: 'subjectsListCode.arabic_listen',         // Écoute & expression orale / Arabic Listening & Speaking
  AR_READ: 'subjectsListCode.arabic_read',             // Lecture arabe / Arabic Reading
  AR_SPELL: 'subjectsListCode.arabic_spell',           // Dictée / Arabic Spelling
  AR_EXO: 'subjectsListCode.arabic_exercises',         // Exercices écrits / Arabic Written Exercises
  AR_APPL: 'subjectsListCode.arabic_applications',     // Applications écrites / Arabic Written Applications
  AR_PROJ: 'subjectsListCode.arabic_project',          // Projet de l’unité / Arabic Project
  AR_GRAM: 'subjectsListCode.arabic_grammar',          // Grammaire arabe / Arabic Grammar
  AR_MORPH: 'subjectsListCode.arabic_morphology',      // Morphologie & conjugaison / Arabic Morphology
  AR_ORAL: 'subjectsListCode.arabic_oral',             // Expression orale / Arabic Oral
  AR_VOWEL: 'subjectsListCode.arabic_vowels',          // Vocalisation (voyellation) / Arabic Vowels
  AR_COMP: 'subjectsListCode.arabic_comprehension',    // Compréhension écrite / Arabic Reading Comprehension
  AR_WRIT: 'subjectsListCode.arabic_writing',          // Rédaction / Arabic Writing
  AR_ORAL2: 'subjectsListCode.arabic_oral_alt',        // Expression orale (variante) / Arabic Oral (alt.)

  // ----- Sous-unités Français -----
  FR_PROJ: 'subjectsListCode.french_project',          // Projet de classe / French Project
  FR_ORAL: 'subjectsListCode.french_oral',             // Activités orales / French Oral
  FR_GRAPH: 'subjectsListCode.french_graph',           // Graphisme / French Graph
  FR_SONG: 'subjectsListCode.french_song',             // Comptine / Chant / French Song
  FR_EXPR: 'subjectsListCode.french_expression',       // Production écrite / French Writing
  FR_LEX: 'subjectsListCode.french_lexicon',           // Lexique / French Vocabulary
  FR_GRAM: 'subjectsListCode.french_grammar',          // Grammaire / French Grammar
  FR_CONJ: 'subjectsListCode.french_conjugation',      // Conjugaison / French Conjugation
  FR_SPELL: 'subjectsListCode.french_spelling',        // Orthographe / Dictée / French Spelling
  FR_COPY: 'subjectsListCode.french_copy',             // Copie / French Copy
  FR_DICT: 'subjectsListCode.french_dictation',        // Dictée / French Dictation
  FR_POEM: 'subjectsListCode.french_poetry',           // Poésie / French Poetry
  FR_READ: 'subjectsListCode.french_reading',          // Lecture / French Reading
  FR_WRITE: 'subjectsListCode.french_writing',         // Écriture / French Writing
  FR_EXO: 'subjectsListCode.french_exercises',         // Exercices écrits / French Exercises
  FR_PROD: 'subjectsListCode.french_production',       // Production écrite / French Writing Production
  FR_LECT: 'subjectsListCode.french_reading_activity', // Activités de lecture / French Reading Activity
  FR_COMM: 'subjectsListCode.french_communication',    // Communication & actes de langage / French Communication
  FR_POEM2: 'subjectsListCode.french_poetry_alt',      // Poésie / Lecture / Diction / French Poetry (alt.)

  // ----- Sous-unités Sociales -----
  HIST: 'subjectsListCode.history',                   // Histoire / History
  GEO: 'subjectsListCode.geography',                  // Géographie / Geography
  CIV: 'subjectsListCode.civics',                     // Éducation civique / Civics
};


export function getSubjectLabelFromCode(code: string, t?: (key: string | TemplateStringsArray | (string | TemplateStringsArray)[], options?: any) => string): string {
  if (!code) return i18n.t("not_available");
  const key = SUBJECT_I18N_KEY[code];
  if (!key) return code; // fallback: show code if unknown
  // if you separated the namespace, include it here, e.g. `t('subjects:arabic')`
  if (!t) return i18n.t(key);
  return t(key);
}

export function getSubjectCodeFromkey(code: string | undefined): string {
  if (!code) return "";
  const key = SUBJECTCODE_I18N_KEY[code];
  if (!key) return code;
  return i18n.t(key);
}


export function getBranchLabelFromCode(
  code: string,
  t: (k: string) => string,
): string {
  // if branches are in a separate namespace, call t with ns, e.g. t(key, { ns: 'branches' })
  return t("branchesList." + code) || code;
}


export function getClassLevelLabelFromCode(
  code: string,
): string {
  // if branches are in a separate namespace, call t with ns, e.g. t(key, { ns: 'branches' })
  return i18n.t("classlevel." + code) || code;
}




// -----------------------for subject coefficients----------------------
// Group a classLevel's subjectCoefficient by branch (null => base group)
export function groupByBranch(list: any[], baseLabel: string) {
  const map: Record<string, { branchId: string | null; branchName: string; items: any[] }> = {};
  for (const item of list) {
    const key = item.branch?.id ?? "no_branch";
    if (!map[key]) {
      map[key] = {
        branchId: item.branch?.id ?? null,
        branchName: getBranchLabelFromCode(item.branch?.labelKey, i18n.t) ?? baseLabel,
        items: [],
      };
    }
    map[key].items.push(item);
  }
  return Object.values(map);
}

// (Optional) Hide base duplicates if the same subject exists in any branch
export function filterBaseDuplicates(groups: ReturnType<typeof groupByBranch>) {
  const branchSubjectIds = new Set<string>();
  for (const g of groups) {
    if (!g.branchId) continue;
    for (const it of g.items) branchSubjectIds.add(it.subject.id);
  }
  return groups.map((g) =>
    g.branchId ? g : { ...g, items: g.items.filter((it) => !branchSubjectIds.has(it.subject.id)) }
  );
}

// Group by parent subject; 'no_parent' bucket for subjects without parent
export function groupByParentSubject(list: any[]) {
  type ParentGroup = {
    parentId: string;
    parent: any | null;
    items: any[];
  };

  const map: Record<string, ParentGroup> = {};

  for (const sc of list) {
    const parent = sc.subject?.parent ?? null;
    const key = parent ? String(parent.id) : "no_parent";
    if (!map[key]) {
      map[key] = { parentId: key, parent, items: [] };
    }
    map[key].items.push(sc);
  }

  return Object.values(map).sort((a, b) => {
    if (a.parentId === "no_parent" && b.parentId !== "no_parent") return -1;
    if (a.parentId !== "no_parent" && b.parentId === "no_parent") return 1;
    return (a.parent?.name || "").localeCompare(b.parent?.name || "");
  });
}

const ALL_HOURS = Array.from({ length: 24 }, (_, i) => i);
const ALL_MINUTES = Array.from({ length: 60 }, (_, i) => i);
export const getDisabledHoursForExitType = (exitType: string, disabledHoursPass?: boolean) => {
  const now = new Date().getHours();
  
  if (exitType === "morning") {
    return ALL_HOURS.filter((hour) => hour < 8 || hour > 12 || (disabledHoursPass && hour < now) );
  }

  if (exitType === "afternoon") {
    return ALL_HOURS.filter((hour) => hour < 14 || hour > 18 || (disabledHoursPass && hour < now));
  }

  if (exitType === "early") {
    return ALL_HOURS.filter((hour) => hour < 8 || hour > 18 || (disabledHoursPass && hour < now));
  }

  return [];
};


export const getDisabledMinutesForExitType = (
  exitType: string,
  selectedHour?: number
) => {

  // if (selectedHour === 12) {
  //   return ALL_MINUTES.filter((minute) => minute > 30);
  // }

  return [];
};
